import React, { memo, Suspense } from 'react';

const ComponentLoad = React.lazy(() => import('./component'));

const LeaveCommentForm = props => (
  <Suspense fallback={null}>
    <ComponentLoad {...props} />
  </Suspense>
);

export default memo(LeaveCommentForm);
